import { Preferences } from "@capacitor/preferences";

const storageKey = "supertokens.cookies";
let cache: string;

async function setKeyValue(key, value) {
  if (cache !== value) {
    cache = value;
    await Preferences.set({ key, value });
  }
}

async function getKeyValue(key) {
  if (cache !== undefined) {
    return cache;
  }

  const value = (await Preferences.get({ key })).value;

  cache = value;

  return cache;
}

async function getCookiesFromStorage() {
  const cookiesFromStorage = await getKeyValue(storageKey);

  if (cookiesFromStorage === null || cookiesFromStorage === undefined) {
    await setKeyValue(storageKey, "[]");

    return "";
  }

  /**
   * Because we store cookies in local storage, we need to manually check
   * for expiry before returning all cookies
   */
  const cookieArrayInStorage = JSON.parse(cookiesFromStorage);
  const cookieArrayToReturn = [];

  for (
    let cookieIndex = 0;
    cookieIndex < cookieArrayInStorage.length;
    cookieIndex++
  ) {
    const currentCookieString = cookieArrayInStorage[cookieIndex];
    const parts = currentCookieString.split(";");
    let expirationString = "";

    for (let partIndex = 0; partIndex < parts.length; partIndex++) {
      const currentPart = parts[partIndex];

      if (currentPart.toLocaleLowerCase().includes("expires=")) {
        expirationString = currentPart;
        break;
      }
    }

    if (expirationString !== "") {
      const expirationValueString = expirationString.split("=")[1];
      const expirationDate = new Date(expirationValueString);
      const currentTimeInMillis = Date.now();

      // if the cookie has expired, we skip it
      if (expirationDate.getTime() < currentTimeInMillis) {
        continue;
      }
    }

    cookieArrayToReturn.push(currentCookieString);
  }

  /**
   * After processing and removing expired cookies we need to update the cookies
   * in storage so we dont have to process the expired ones again
   */
  setKeyValue(storageKey, JSON.stringify(cookieArrayToReturn));

  return cookieArrayToReturn.join("; ");
}

async function setCookieToStorage(cookieString) {
  const cookieName = cookieString.split(";")[0].split("=")[0];
  const cookiesFromStorage = await getKeyValue(storageKey);
  let cookiesArray = [];

  if (cookiesFromStorage !== null && cookiesFromStorage !== undefined) {
    const cookiesArrayFromStorage = JSON.parse(cookiesFromStorage);

    cookiesArray = cookiesArrayFromStorage;
  }

  let cookieIndex = -1;

  for (let i = 0; i < cookiesArray.length; i++) {
    const currentCookie = cookiesArray[i];

    if (currentCookie.indexOf(`${cookieName}=`) !== -1) {
      cookieIndex = i;
      break;
    }
  }

  /**
   * If a cookie with the same name already exists (index != -1) then we
   * need to remove the old value and replace it with the new one.
   *
   * If it does not exist then simply add the new cookie
   */
  if (cookieIndex !== -1) {
    cookiesArray[cookieIndex] = cookieString;
  } else {
    cookiesArray.push(cookieString);
  }

  await setKeyValue(storageKey, JSON.stringify(cookiesArray));
}

export function CrossPlatformCookieHandler(original) {
  return {
    ...original,
    getCookie: async function () {
      const cookies = await getCookiesFromStorage();

      return cookies;
    },
    setCookie: async function (cookieString) {
      return await setCookieToStorage(cookieString);
    },
  };
}
